<template>
	<g>
		<g>
			<path
				class="st0"
				:style="'stroke: ' + strokeColor"
				d="M24.4,74.1c2.4,0.9,5.1,1,6.5,1c0.7,0,1.3,0,2,0c1.4,0,4-0.1,6.5-1c0.5-0.2,0.9-0.6,0.9-1.1V40.8
			c0-0.2,0-0.4,0-0.6c0-0.5-0.1-2-2.2-4.4c-0.9-1-1.4-2.2-1.5-3.4l-1.1-14.5c0,0,1.6-0.6,0.4-2.3c-0.1-0.1-0.2-0.2-0.3-0.3
			c-0.1-0.1-0.2-0.2-0.2-0.5c0-0.3,0.1-0.5,0.3-0.7c0.2-0.2,0.5-0.5,0.1-0.9c-0.2-0.2-0.5-0.3-0.8-0.3h-3.1h-3.1
			c-0.3,0-0.6,0.1-0.8,0.3c-0.4,0.3-0.1,0.7,0.1,0.9c0.2,0.2,0.4,0.5,0.3,0.7c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.2,0.2-0.3,0.3
			c-1.2,1.7,0.4,2.3,0.4,2.3l-1.1,14.5c-0.1,1.2-0.6,2.4-1.5,3.4c-2.2,2.4-2.3,4-2.2,4.4c0,0.2,0,0.4,0,0.6V73
			C23.5,73.5,23.8,73.9,24.4,74.1z"
			/>
			<path
				class="st1"
				:style="'stroke: ' + strokeColor"
				d="M40.7,64.6c-2.1,0.7-4.3,0.8-5.5,0.8c-0.6,0-1.1,0-1.7,0c-1.2,0-3.4-0.1-5.5-0.8c-0.4-0.2-0.7-0.5-0.7-1
			l0-18.2c0-0.5,0.6-0.9,1.1-0.8c2.2,0.4,6.5,0.6,11.8,0.1"
			/>
			<path
				class="st2"
				:style="'stroke: ' + strokeColor"
				d="M28.3,17.9"
			/>
			<line
				class="st1"
				:style="'stroke: ' + strokeColor"
				x1="27.9"
				y1="15.6"
				x2="35.8"
				y2="15.6"
			/>
		</g>
		<g>
			<path
				class="st3"
				:style="'stroke: ' + strokeColor"
				d="M68.4,73.4C68.4,73.4,68.4,73.4,68.4,73.4C68.4,73.4,68.4,73.4,68.4,73.4c-0.8-0.4-4.1-0.8-6.9-1.6
			c-1.5-0.4-2.3-0.7-2.8-1.2l0,0c0,0-0.1-0.1-0.1-0.2c0,0,0,0,0,0c0-0.1-0.1-0.1-0.1-0.2c0,0,0,0,0,0c0-0.1-0.1-0.1-0.1-0.2
			c0,0,0,0,0,0c0-0.1,0-0.1-0.1-0.2c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0c0-0.1,0-0.2,0-0.2
			c0,0,0,0,0,0c0-0.1,0-0.2,0-0.3c0-1.6,0-13.8,0-15.6c0-0.1,0-0.2,0-0.2c0-0.1,0-0.1,0-0.2c0.1-0.8,0.3-1.4,0.4-1.6c0,0,0,0,0,0
			c0-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0-0.1,0.1-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0-0.1,0.1-0.1
			c0,0,0,0,0,0c0,0,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0,0,0,0
			c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0.1-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0.1-0.1,0.1-0.1,0.2-0.2
			c0.4-0.4,0.9-0.8,1.5-1.4c0,0,0,0,0,0c0,0,0,0,0,0c0.6-0.5,1.3-1.1,2.2-2c3.5-3.3,7-4.7,6.8-13.3c-0.1-3.3-1.3-10.6-1.9-12.6H46.3
			c-0.4,1.5-2.1,9.6-1.9,15.5c0.1,2.5,1.3,5.7,4.1,7.9c1.6,1.3,3.3,2.8,4.8,4.1c0,0,0,0,0,0c0,0,0,0,0,0c0.5,0.4,1,0.9,1.4,1.2
			c0.1,0,0.1,0.1,0.2,0.1c0,0,0,0,0,0c0,0,0,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.1,0.2,0.2,0.2c0,0,0,0.1,0.1,0.1
			c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1
			c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0.1,0.1c0,0,0,0.1,0.1,0.1c0,0,0,0.1,0.1,0.1c0,0,0,0.1,0.1,0.1c0,0,0,0.1,0.1,0.1
			c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0.2,0.4,0.3,0.7,0.4,1.5c0,0,0,0,0,0c0,0,0,0,0,0c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3
			c0,1.7,0,13.9,0,15.6c0,0.1,0,0.2,0,0.2c0,0,0,0,0,0c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0
			c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0c0,0.1-0.1,0.2-0.1,0.4c0,0,0,0,0,0c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1
			c-0.5,0.5-1.3,0.8-2.9,1.3c-2.8,0.8-6.1,1.2-6.8,1.6c0,0,0,0,0,0c0,0,0,0,0,0c-0.3,0.2-0.4,0.7,0,0.8c0.5,0.1,3.4,0.5,10.9,0.7
			c7.5-0.2,10.5-0.7,10.9-0.7C68.9,74.1,68.7,73.6,68.4,73.4z"
			/>
			<ellipse
				class="st1"
				cx="57.4"
				cy="30.4"
				rx="13.1"
				ry="1.1"
				:style="'stroke: ' + strokeColor"
			/>
		</g>
	</g>
</template>

<script>
export default {
	props: {
		strokeColor: { type: String }
	}
};
</script>

<style scoped>
.st0 {
	stroke-width: 2.3631;
	stroke-miterlimit: 10;
}
.st1 {
	stroke-width: 1.0025;
	stroke-miterlimit: 10;
}
.st2 {
	stroke-width: 0.3939;
	stroke-miterlimit: 10;
}
.st3 {
	stroke-width: 2.3631;
	stroke-linecap: round;
	stroke-linejoin: round;
	stroke-miterlimit: 10;
}
</style>

<style>
.icon-wrapper:hover .st0,
.icon-wrapper:hover .st1,
.icon-wrapper:hover .st2,
.icon-wrapper:hover .st3 {
	stroke: #f1560f !important;
}
</style>